<template>
  <div class="content">
    <fade-transition :duration="100" mode="out-in">
      <!-- your content here -->
      <router-view></router-view>
    </fade-transition>
  </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";
export default {
  components: {
    FadeTransition
  }
};
</script>
<style scoped>
.main-panel > .content {
  padding: 10px 20px 0px 20px;
  min-height: 65vh;
}
</style>
